import { render, staticRenderFns } from "./BookingChannelSettingsMenu.vue?vue&type=template&id=6cdbc87c&scoped=true&"
import script from "./BookingChannelSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./BookingChannelSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BookingChannelSettingsMenu.vue?vue&type=style&index=0&id=6cdbc87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdbc87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VList,VListItem,VListItemGroup,VListItemIcon,VListItemTitle,VSubheader})
